// Nested reducers
import { currenciesReducer } from "./currencies/currencies.reducer";
import { interestRatesReducer } from "./interest-rates/interest-rates.reducer";
import { paymentTermsReducer } from "./payment-terms/payment-terms.reducer";
import { deliveryTermsReducer } from "./delivery-terms/delivery-terms.reducer";
import { salesCreditRolesReducer } from "./sales-credit-roles/sales-credit-roles.reducer";
import { companiesReducer } from "./companies/companies.reducer";
import { financingCompaniesReducer } from "./financing-companies/financing-companies.reducer";
import { externalUsersReducer } from "./users/external-users/external-users.reducer";
import { internalUsersReducer } from "./users/internal-users/internal-users.reducer";
import { countriesReducer } from "./countries/countries.reducer";
import { quoteSearchReducer } from "./quote-search/quote-search.reducer";

// **************************************************************************
// SUPER USER REDUCER
// **************************************************************************

export const superUserReducer = [
    ...currenciesReducer,
    ...interestRatesReducer,
    ...paymentTermsReducer,
    ...deliveryTermsReducer,
    ...salesCreditRolesReducer,
    ...companiesReducer,
    ...financingCompaniesReducer,
    ...externalUsersReducer,
    ...internalUsersReducer,
    ...countriesReducer,
    ...quoteSearchReducer,
];
